import { Link } from 'wouter';
import { accountAccess, useAuth } from '../state';
import './nav.css';

/**
 * "Your access" row: tells every member what kind of account they have
 * (Operator, team, VIP tester, tester, paid plan, or free) in plain words.
 * Links to the subscription page, where the details live.
 */
export function AccountAccessRow({ onNavigate, compact = false }: { onNavigate?: () => void; compact?: boolean }) {
  const profile = useAuth((s) => s.profile);
  if (!profile) return null;
  const a = accountAccess(profile);
  // Compact (desktop rail): one row, eyebrow left and pill right, with the
  // detail in the tooltip, so the pinned footer stays short.
  if (compact) {
    return (
      <Link
        href="/settings/subscription"
        className="acct-access acct-access--compact"
        onClick={onNavigate}
        title={`${a.label}: ${a.detail}. Open to see what's included.`}
      >
        <span className="acct-access__eyebrow">Your access</span>
        <span className={`acct-access__pill acct-access__pill--${a.tone}`}>{a.label}</span>
      </Link>
    );
  }
  return (
    <Link
      href="/settings/subscription"
      className="acct-access"
      onClick={onNavigate}
      title="Your account type. Open to see what's included."
    >
      <span className="acct-access__eyebrow">Your access</span>
      <span className="acct-access__line">
        <span className={`acct-access__pill acct-access__pill--${a.tone}`}>{a.label}</span>
        <span className="acct-access__detail">{a.detail}</span>
      </span>
    </Link>
  );
}

/** Just the pill, for tight spots (the account menu header). */
export function AccountAccessPill() {
  const profile = useAuth((s) => s.profile);
  if (!profile) return null;
  const a = accountAccess(profile);
  return <span className={`acct-access__pill acct-access__pill--${a.tone}`}>{a.label}</span>;
}
